import createClient, { type FetchOptions } from 'openapi-fetch';
import type { paths } from '@/types/api';

export type { FetchOptions };

export const useOpenApiClient = () => {
  const config = useRuntimeConfig();

  const client = createClient<paths>({
    baseUrl: config.public.apiEndpoint,
  });

  return { client };
};
